/**
 * Match a finish against a search query, including UI-style "name / metric" input.
 */
export function matchesFinishSearch(item, rawQuery) {
    const search = rawQuery.trim();
    if (!search) {
        return true;
    }
    const normalized = search.replace(/\s*\/\s*/g, '/');
    const lower = (value) => value.toLowerCase();
    if (normalized.includes('/')) {
        const slashIndex = normalized.indexOf('/');
        const namePart = normalized.slice(0, slashIndex).trim();
        const metricPart = normalized.slice(slashIndex + 1).trim();
        if (!namePart && !metricPart) {
            return true;
        }
        if (namePart && !lower(item.name).includes(lower(namePart))) {
            return false;
        }
        if (metricPart && !(item.metric_name && lower(item.metric_name).includes(lower(metricPart)))) {
            return false;
        }
        return true;
    }
    const query = lower(search);
    return lower(item.name).includes(query) || Boolean(item.metric_name && lower(item.metric_name).includes(query));
}
